import { PersonDataService } from "../../../core/persons.dataservice";
import { WorkplaceDataService } from "../../../core/workplaces.dataservice";
import { Ng2StateDeclaration } from "@uirouter/angular";

import { PersonWorkplaceEditComponent } from "./person.workplace.edit.component";
import { PersonWorkplaceComponent } from "./person.workplace.component";

import * as dataCore from "../../../core/datacore";

export const personWorkplacesEditState: Ng2StateDeclaration = {
    name: "app.resources.persons.workplaces.edit",
    url: "/{personWorkplaceId:int}",
    views: {
        "main-view@app": {
            component: PersonWorkplaceEditComponent
        }
    },
    resolve: {
        isNew: () => false,
        personWorkplace: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.getPersonWorkplace($stateParams.personWorkplaceId);
        }],
        person: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.get($stateParams.personId);
        }],
        workplaces: [WorkplaceDataService.Id, function (workplaceDataService: WorkplaceDataService) {
            return workplaceDataService.getAll();
        }]
    }
};

export const personWorkplacesNewState: Ng2StateDeclaration = {
    name: "app.resources.persons.workplaces.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: PersonWorkplaceEditComponent
        }
    },
    resolve: {
        isNew: () => true,
        person: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.get($stateParams.personId);
        }],
        workplaces: [WorkplaceDataService.Id, function (workplaceDataService: WorkplaceDataService) {
            return workplaceDataService.getAll();
        }],
        personWorkplace: ["person", "workplaces", function (person: Nema.Crew.Model.Person, workplaces: Nema.Crew.Model.Workplace[]) {
            return <Nema.Crew.Model.PersonWorkplace>{
                PersonId: person.Id,
                WorkplaceId: workplaces[0].Id,
                FromDate: dataCore.getTodayUTC()
            };
        }]
    }
};

export const personWorkplacesDetailsState: Ng2StateDeclaration = {
    name: "app.resources.persons.workplaces.detail",
    url: "/{personWorkplaceId:int}",
    views: {
        "main-view@app": {
            component: PersonWorkplaceComponent
        }
    },
    resolve: {
        personWorkplace: [PersonDataService.Id, "$stateParams", function (personsService: PersonDataService, $stateParams) {
            return personsService.getPersonWorkplace($stateParams.personWorkplaceId);
        }],
        workplaces: [WorkplaceDataService.Id, "$stateParams", function (workplaceDataService: WorkplaceDataService) {
            return workplaceDataService.getAll();
        }],
        isNew: function () {
            return false;
        }
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/resources/persons/workplaces/person.workplaces.states.ts